import { React, useState, useEffect } from "react";
import "./LogIn.css";
import { UserAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

function LogIn() {
  const [logInDetails, setLogInDetails] = useState({
    username: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const { session, signInUser } = UserAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const result = await signInUser({
        email: logInDetails.username,
        password: logInDetails.password,
      });
      if (result.success) {
        navigate("/dashboard");
      } else {
        setError(result.error);
        setLoading(false);
      }
    } catch (error) {}
  };

  useEffect(() => {
    function checkForUser() {
      if (session) {
        navigate("/dashboard");
      }
    }
    checkForUser();
  }, [session, navigate]);

  return (
    <div className="login_main_container">
      <div className="login_popup_container">
        <img
          className="login_logo"
          src="/images/logo_white_256.webp"
          alt="GoMove Logo"
        />
        <h2>Log In</h2>
        <form className="login_form">
          <input
            placeholder="Usuario"
            value={logInDetails.username}
            onChange={(e) => {
              setLogInDetails({ ...logInDetails, username: e.target.value });
            }}
          />
          <input
            placeholder="Contraseña"
            value={logInDetails.password}
            type="password"
            onChange={(e) => {
              setLogInDetails({ ...logInDetails, password: e.target.value });
            }}
          />
          <button disabled={loading} onClick={handleLogin}>
            Iniciar Sesión
          </button>
          {error ? <div className="login_error">{error}</div> : ""}
        </form>
      </div>
    </div>
  );
}

export default LogIn;
